import script from "./HowToLock.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowToLock.vue?vue&type=script&setup=true&lang=ts"

import "./HowToLock.vue?vue&type=style&index=0&id=af662d90&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af662d90"]])

export default __exports__